import { getServerBlockType } from "@pathwright/blocks-core"
import {
  blockStyleMenuOptions,
  defaultBlockStyles
} from "./base-style-defaults"

export const getStylesForOption = (toolKey, option, currentStyles = {}) => {
  const tool = blockStyleMenuOptions.block.tools.find((t) => t.key === toolKey)

  if (!tool) {
    console.warn(`No style tool found for key: ${toolKey}`)
    return currentStyles
  }

  const nextStyles = {
    selectedSettings: {
      ...(currentStyles.selectedSettings || {}),
      [toolKey]: option
    },
    styleAttributes: {
      ...(currentStyles.styleAttributes || {}),
      ...tool.handler(option)
    }
  }

  return nextStyles
}

export const getStylesForColorChange = (
  nextCustomColors,
  currentStyles = {}
) => {
  const nextStyles = {
    styleAttributes: {
      ...(currentStyles.styleAttributes || {}),
      ...nextCustomColors
    },
    selectedSettings: {
      ...(currentStyles.selectedSettings || {}),
      blockColor: "custom"
    }
  }

  return nextStyles
}

export const getStyles = (block = null, blockStyles = null) => {
  let style = {
    ...defaultBlockStyles,
    ...(block && block.style ? block.style : {})
  }

  if (blockStyles) {
    style = { ...style, ...blockStyles }
  }

  // These shouldn't be saved on the server
  delete style.styleOptions
  delete style.__typename

  return style
}

export const getBlockTypeLayoutOptions = ({ type, blockTypes }) => {
  const BT = getServerBlockType(type, blockTypes)
  return Object.values(BT.layouts || [])
}

const lsKey = "customBlocksColors"

export const getCustomColors = () =>
  JSON.parse(window.localStorage.getItem(lsKey))

export const setCustomColors = (nextCustomColors = []) => {
  window.localStorage.setItem(lsKey, JSON.stringify(nextCustomColors))
}

export const clearCustomColors = () => {
  window.localStorage.removeItem(lsKey)
}
